import { Grid, Box, Typography, SvgIcon } from '@mui/material';
import { PlusIcon } from 'components/SVG';
import React from 'react';
import { SparkButton } from 'sharedComponents/UI';
import WorkspaceListSearch from './WorkspaceListSearch';
import { useDialog } from 'hooks/common/useDialog';
import AddWorkspaceDialog from 'components/Dashboard/Modals/AddWorkspaceDialog';
import { useResize } from 'hooks/common';

function WorkspaceContainer() {
  const { isMobile } = useResize();

  const {
    open: isCreateWorkspaceModalOpen,
    openDialog: openCreateWorkspaceModal,
    closeDialog: closeCreateWorkspaceModal,
  } = useDialog();

  return (
    <Grid container justifyContent='center' padding={isMobile ? 2 : 3}>
      <Grid item alignItems='center' xs={12}>
        <Box display='flex' align-items='center' justifyContent='space-between'>
          <Typography
            variant='h4'
            sx={{
              color: '#404040',
              fontFamily: 'Mont-semibold',
            }}
          >
            Workspaces
          </Typography>
          <SparkButton
            variant='contained'
            onClick={() => openCreateWorkspaceModal()}
            startIcon={
              <SvgIcon
                sx={{
                  '& path': {
                    fill: 'white',
                  },
                  stroke: 'white',
                  paddingTop: '5px',
                }}
              >
                {<PlusIcon color='white' />}
              </SvgIcon>
            }
          >
            <Typography variant='body1'>Add Workspace</Typography>
          </SparkButton>
        </Box>
        <WorkspaceListSearch />
      </Grid>

      <AddWorkspaceDialog
        open={isCreateWorkspaceModalOpen}
        onClose={closeCreateWorkspaceModal}
      />
    </Grid>
  );
}

export default WorkspaceContainer;
